module.exports = __webpack_public_path__ + "static/media/PB_Y_11.eedf6a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_11.png
// module id = 240
// module chunks = 0